import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Adventure from "./sections/Adventure";
import HolidaySpecials from "./sections/HolidaySpecials";
import Expertise from "./sections/Expertise";
import Getaways from "./sections/Getaways";
import Destinations from "./sections/Destinations";
import TravelBlog from "./sections/TravelBlog";
import FlightSpecials from "./sections/FlightSpecials";
import Testimonials from "./sections/Testimonials";
import Insurance from "./sections/Insurance";
import Partners from "./sections/Partners";
import Connect from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Adventure />
      <HolidaySpecials />
      <Expertise />
      <Getaways />
      <Destinations />
      <TravelBlog />
      <FlightSpecials />
      <Testimonials />
      <Insurance />
      <Partners />
      <Connect />
    </div>;
}